import axios from 'axios';
import { toGeoSuggestsUI } from '../../mappers/geo/toGeoSuggestsUI';
import { GeoSuggestModel, GeoSuggestsUI } from './types';

export async function loadGeoSuggest(query: string): Promise<GeoSuggestsUI> {
    const response = await axios.get(`/geo/region-suggest?query=${query}`);

    const suggests: GeoSuggestModel[] = response.data?.suggests || [];

    return { suggests: suggests.map(toGeoSuggestsUI) };
}
